import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/utils';
import { XIcon } from 'lucide-react';

interface ImageUploadProps {
    label?: string,
    caption?: string,
    className?: string,
    classNameImg?: string,
    urlImagePreview: string,
    isShowX?: boolean,
    clearImg?: Function
}

const ImageUploadShow: React.FC<ImageUploadProps> = ({
    caption = '',
    className,
    classNameImg,
    urlImagePreview,
    isShowX = false,
    clearImg
}) => {
    const { t } = useTranslation();
    const [imagePreview, setImagePreview] = useState<string | null>(urlImagePreview || null);

    useEffect(() => {
        if (urlImagePreview) {
            setImagePreview(urlImagePreview);
        }
    }, [urlImagePreview]);

    return (
        <div className='flex flex-col'>
            {imagePreview ?
                (
                    <div className={cn('relative h-fit w-full border border-input rounded-lg', className)}>
                        <img
                            src={imagePreview}
                            alt=''
                            className={cn('h-48 w-full object-contain rounded-lg', classNameImg)}
                        />
                        {caption && (
                            <div className='flex items-center justify-center bg-background-12 w-full rounded-b-md h-8'>
                                <p className='line-clamp-1 p-1'>{caption}</p>
                            </div>
                        )}
                        {isShowX && (
                            <button
                                type='button'
                                title='Remove image'
                                onClick={() => {
                                    clearImg?.(urlImagePreview);
                                }}
                                className='absolute top-1 right-1 bg-black bg-opacity-50 rounded-full p-1 shadow-lg'
                            >
                                <XIcon className='w-3 h-3 text-white' />
                            </button>
                        )}
                    </div>
                ) :
                (
                    <div
                        className={cn('w-full h-fit flex flex-col items-center justify-center rounded-lg border border-input', className)}
                    >
                        <div className='flex flex-col items-center justify-center h-48'>
                            <p className='mt-1 text-placeholder'>{t('sentences.no_data')}</p>
                        </div>
                        {caption && (
                            <div className='flex items-center justify-center bg-background-12 w-full rounded-b-lg h-8'>
                                <p className='line-clamp-1 p-1'>{caption}</p>
                            </div>
                        )}
                    </div>
                )}
        </div>
    );
};

export default ImageUploadShow;
